import CommonPalette from "../../../core/gd/skin/skin-palette/common-palette";
import {SkinCommonColorPalette} from "../../../core/gd/skin/skin-palette/@type";
import {SkinTheme} from "../@const";

const COMMON_LIGHT: SkinCommonColorPalette = {
    'palette-white'                         : '#FFFFFF',
    'bg-content-plate-on-gray'              : '#FFFFFF',

    // Font colors
    'palette-font-default'                  : '#000000',
    'palette-font-less-important'           : '#353E4A',
    'palette-font-not-important'            : '#5E6267',
    'palette-font-disabled'                 : '#ABACAE',
    'palette-font-disabled-on-gray'         : '#A4A7AB',
    'palette-font-no-accent'                : '#787B80',
    'palette-font-no-accent-on-gray'        : '#74787D',
    'palette-font-title'                    : '#394557',
    'palette-font-white'                    : '#FFFFFF',
    'palette-font-black'                    : '#000000',
    'palette-font-on-pale-bg'               : '#353E4A',
    'palette-font-on-color-bg'              : '#FFFFFF',
    'palette-font-less-important-on-pale'   : '#353E4A',
    'palette-font-text-link'                : '#0068FF',
    'temp-palette-font-hmenu'               : '#5E6267',

    // Highlight colors
    'palette-highlight-blue'                : '#ebf3ff',//'#F2FAFF',
    'palette-highlight-blue-light'          : '#FCFDFE',
    'palette-menu-item-hover-color'         : '#f2f5f7',

    'palette-system-action-dark'            : '#044AFF', // '#3481FF',
    'palette-system-action'                 : '#1970ff',
    'palette-system-action-light'           : '#598EF8'
}

const COMMON_DARK: SkinCommonColorPalette = {
    'palette-white'                         : '#1D1F21',
    'bg-content-plate-on-gray'              : '#2a2c2e',

    // Font colors
    'palette-font-default'                  : '#d9d9d9',
    'palette-font-less-important'           : '#c1c3c6',
    'palette-font-not-important'            : '#a9acae',
    'palette-font-disabled'                 : '#787B80',
    'palette-font-disabled-on-gray'         : '#787B80',
    'palette-font-no-accent'                : '#787B80',
    'palette-font-no-accent-on-gray'        : '#BBBBBB',
    'palette-font-title'                    : '#FCFCFC',
    'palette-font-white'                    : '#FFFFFF',
    'palette-font-black'                    : '#000000',
    'palette-font-on-pale-bg'               : '#1A222C',
    'palette-font-on-color-bg'              : '#1A222C',
    'palette-font-less-important-on-pale'   : '#000000',
    'palette-font-text-link'                : '#8ab4f8',
    'temp-palette-font-hmenu'               : '#767a81',

    // Highlight colors
    'palette-highlight-blue'                : '#323439',
    'palette-highlight-blue-light'          : '#323439',
    'palette-menu-item-hover-color'         : '#37393d',

    'palette-system-action-dark'            : '#3481FF',
    'palette-system-action'                 : '#8ab4f8',
    'palette-system-action-light'           : '#8ab4f8',

}

const DEFAULT_PALETTE = SkinTheme.LIGHT // SkinTheme used like key for palette dictionary

const debug = false
// const debug = "CommonPaletteAsana"

export default class CommonPaletteAsana extends CommonPalette {

    constructor(currentPalette = DEFAULT_PALETTE) {

        super(currentPalette)

        this.palettes = {
            [SkinTheme.LIGHT]   : COMMON_LIGHT,
            [SkinTheme.DARK]    : COMMON_DARK
        }

        debug && console.log(debug, 'constructor', this.palettes[this.currentPalette])

        this.setPalette(this.currentPalette)
    }
}
